declare const __WEBPACK_ASSETS_PATH: string;
declare const __WEBPACK_BUILD_VERSION: string;
export const ASSETS_PATH = __WEBPACK_ASSETS_PATH;
// BUILD_VERSION is needed to force the browser to fetch the updated sprite because sometimes the sprite contains a new SVG, but the browser loads the old one from the cache
export const BUILD_VERSION = __WEBPACK_BUILD_VERSION;

declare const __WEBPACK_API_ROOT: string;
export const API_PATH = __WEBPACK_API_ROOT;

declare const APPCONFIG: AppConfig;
if (typeof APPCONFIG == 'undefined') {
    console.log('%cZdefiniuj APPCONFIG, bo inaczej życie nie ma sensu...', 'color:teal');
}
export const APP_CONFIG = APPCONFIG;

export const KEYS = {
    tab: 9,
    up: 38,
    right: 39,
    down: 40,
    left: 37,
    enter: 13,
    space: 32,
    esc: 27,
    end: 35,
    home: 36
};
// Classes state 'is--[state_name]'
export const CLASS_IS_SHOW = 'is--show';
export const CLASS_IS_HIDE = 'is--hide';
export const CLASS_IS_VISIBLE = 'is--visible';
export const CLASS_IS_HIDDEN = 'is--hidden';
export const CLASS_IS_ACTIVE = 'is--active';
export const CLASS_IS_LOCKED_POSITION = 'is--lockedPosition';
export const CLASS_IS_SHOWN = 'is--shown';
export const CLASS_IS_DISABLE_HOVER = 'is--disableHover';
export const CLASS_IS_NOSCROLL = 'is--noscroll';
export const CLASS_IS_ACTIVE_UI = 'is--activeUI';
export const CLASS_IS_DISABLED = 'is--disabled';
export const CLASS_IS_LOADING = 'is--loading';
export const CLASS_IS_LOCKED = 'is--locked';
export const CLASS_IS_HIDDENMOB = 'is--hiddenMob';
export const CLASS_IS_FLEX = 'is--flex';

export const FUNC_KEYS = ['Down','ArrowDown','Up','ArrowUp','Left','ArrowLeft','Right','ArrowRight','Home','End','Delete','Backspace','Shift','Ctrl','Tab'];

export const RECONFIGURE_PIZZAID_KEY = 'reconfigurePizzaId'
export const PROD_IN_STEP_CART_ID = 'prodInStepCartId'
